export default __webpack_public_path__ + "static/media/404_6.bb6ab13c.png";